import { FC } from 'react';

import { NOTIFICATION_TYPES } from '@savgroup-front-common/constants';

import Banner from '../../../../../../../../atoms/Banners/Banner';
import FormGroup from '../../../../../../../../atoms/Form/FormGroup';
import { SafeFormattedMessageWithoutSpread } from '../../../../../../../../formatters/SafeFormattedMessageWithoutSpread';
import messages from '../../messages';

import { $EmptyWeek } from './EmptyWeekLegacy.styles';

const EmptyWeekLegacy: FC = () => {
  return (
    <$EmptyWeek>
      <FormGroup>
        <Banner
          notificationType={NOTIFICATION_TYPES.DEFAULT}
          hollow
          hasIcon={false}
        >
          <SafeFormattedMessageWithoutSpread
            message={messages.noAvailableTechnicalInterventionSlotsForThisPage}
          />
        </Banner>
      </FormGroup>
    </$EmptyWeek>
  );
};

EmptyWeekLegacy.displayName = 'EmptyWeekLegacy';

export default EmptyWeekLegacy;
